const RETRY_COUNT_CDN_ROTATION = 2;
const RETRY_COUNT_API_SERVICE_DEFAULT = 1;
const RETRY_COUNT_API_SERVICE_PLAYBACK = 2;
const RETRY_COUNT_API_SERVICE_PRECISION = 2;
const RETRY_COUNT_API_SERVICE_CONCURRENCY = 2;
const RETRY_COUNT_API_SERVICE_RESUMEPOINTS = 2;

export {
    RETRY_COUNT_CDN_ROTATION,
    RETRY_COUNT_API_SERVICE_DEFAULT,
    RETRY_COUNT_API_SERVICE_PLAYBACK,
    RETRY_COUNT_API_SERVICE_PRECISION,
    RETRY_COUNT_API_SERVICE_CONCURRENCY,
    RETRY_COUNT_API_SERVICE_RESUMEPOINTS,
};
